<style scope>

</style>

<template>
    <div>
        <van-nav-bar left-arrow left-text="返回" title="项目详情" @click-left="back">
           <!-- <van-icon name="plus" slot="right" />-->
        </van-nav-bar>
        <van-cell-group>
            <van-field
                    label="产品"
                    type="input"
                    placeholder="房抵贷一押"
                    rows="1"
                    autosize
            />
            <van-cell title="借款人" is-link value="张三"/>
            <van-cell title="共借人" is-link value="李四"/>
            <van-cell title="借款用途" is-link value="生意周转"/>
            <van-field
                    label="借款金额"
                    type="number"
                    placeholder="例如：200000"
                    rows="1"
                    autosize
            >
                <van-button slot="button" size="mini" type="default">250万</van-button>
            </van-field>

            <van-field
                    label="年利率(%)"
                    type="number"
                    rows="1"
                    value="17"
                    autosize
            /><van-field
                    label="服务费率(%)"
                    type="number"
                    rows="1"
                    value="2"
                    autosize
            />
            <van-cell title="还款方式" is-link value="等本等息"/>
            <van-field
                    label="借款描述"
                    type="textarea"
                    placeholder=""
                    rows="4"
            />
        </van-cell-group>

    </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'application',
    props: {},
    computed: {},
    watch: {},
    data: function () {
      return {
        message: ''
      }
    },
    methods: {
      back() {
        this.$router.go(-1)
      }
    },
    mounted () {

    },
    destroyed () {

    }
  }
</script>
